import * as color from 'color';

const themeColors: {
  primaryColor: color;
  secondaryColor: color;
  warningColor: color;
  dangerColor: color;
  successColor: color;
  infoColor: color;
  roseColor: color;
  grayColor: color;
  white: color;
  black: color;
  cornerColors: {
    activity: color;
    activityContrast: color;
    reward: color;
    rewardContrast: color;
    promotion: color;
    promotionContrast: color;
    game: color;
    gameContrast: color;
  };
} = {
  primaryColor: color('#0057B8').mix(color('#000000'), 0.0),
  secondaryColor: color('#F3D03E').mix(color('#000000'), 0.0),
  warningColor: color('#FFCD4F'),
  dangerColor: color('#D22E0C'),
  successColor: color('#1FC696'),
  infoColor: color('#00acc1'),
  roseColor: color('#e91e63'),
  grayColor: color('#999999'),
  white: color('#ffffff'),
  black: color('#000000'),
  cornerColors: {
    activity: color('#0A548B'),
    activityContrast: color('#FFFFFF'),
    reward: color('#FECC36'),
    rewardContrast: color('#000000'),
    promotion: color('#FF4832'),
    promotionContrast: color('#000000'),
    game: color('#36B1E6'),
    gameContrast: color('#000000')
  }
};

export type ColorProps = 'initial' | 'inherit' | 'primary' | 'secondary' | 'textPrimary' | 'textSecondary' | 'error';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  themeColors
};
